/*
 * ILRES cart rules
 * 1) One of each class type per cart (75-hour / self-paced pre-license class, State Exam Test Prep,
 *    Success in 60 Days, Managing Broker License). Different types can share a cart.
 *    Adding a second one of the same type replaces the first. Quantity is capped at 1.
 * 2) Shows the Terms checkbox app inline above Check out in the cart drawer (no popup), so there is
 *    one tick and the order is still stamped 'Agreed to the Terms and Conditions & Refund Policy on <date>'.
 * Loaded from snippets/custom.liquid. Edit the GROUPS list if a new product family is added.
 */
(function () {
  'use strict';
  if (window.__ilresCartRules) return;
  window.__ilresCartRules = true;

  var GROUPS = [
    { id: 'class75', label: '75-hour class', test: function (h) {
      if (h.slice(-8) === '-upgrade') return false;
      return h.indexOf('75-hr-broker-pre-license') === 0 || h.slice(-25) === 'broker-pre-license-course';
    } },
    { id: 'stateexam', label: 'State Exam Test Prep', test: function (h) { return h.indexOf('state-exam-test-prep') === 0; } },
    { id: 'si60', label: 'Success in 60 Days', test: function (h) { return h.indexOf('success-in-60-days') === 0; } },
    { id: 'managing', label: 'Managing Broker License', test: function (h) { return h.indexOf('managing-broker-license') === 0; } }
  ];

  var nativeFetch = window.fetch.bind(window);
  var known = null;
  var busy = false;
  var again = false;

  function isAdd(url) {
    var u = String(url || '').split('?')[0];
    return /\/cart\/(add|change|update)(\.js)?$/.test(u);
  }

  function groupOf(item) {
    var h = item && item.handle ? String(item.handle) : '';
    for (var i = 0; i < GROUPS.length; i++) { if (GROUPS[i].test(h)) return GROUPS[i]; }
    return null;
  }

  function keysOf(cart) {
    var o = {};
    (cart.items || []).forEach(function (it) { o[it.key] = true; });
    return o;
  }

  function buildPlan(cart) {
    var buckets = {};
    (cart.items || []).forEach(function (it) {
      var g = groupOf(it);
      if (!g) return;
      if (!buckets[g.id]) buckets[g.id] = { g: g, items: [] };
      buckets[g.id].items.push(it);
    });
    var updates = {};
    var notes = [];
    var changed = false;
    Object.keys(buckets).forEach(function (id) {
      var items = buckets[id].items;
      var keep = items[0];
      if (known) {
        for (var i = 0; i < items.length; i++) { if (!known[items[i].key]) { keep = items[i]; break; } }
      }
      items.forEach(function (it) { if (it.key !== keep.key) { updates[it.key] = 0; changed = true; } });
      if (keep.quantity > 1) { updates[keep.key] = 1; changed = true; }
      if (items.length > 1) notes.push({ label: buckets[id].g.label, title: keep.product_title });
    });
    return { changed: changed, updates: updates, notes: notes };
  }

  function showNote(notes) {
    if (!notes.length) return;
    try {
      var drawer = document.querySelector('cart-drawer');
      var inner = document.querySelector('#CartDrawer .drawer__inner');
      if (!inner) return;
      var old = inner.querySelector('.ilres-cart-note');
      if (old) old.remove();
      var n = notes[0];
      var div = document.createElement('div');
      div.className = 'ilres-cart-note';
      div.setAttribute('role', 'status');
      div.style.cssText = 'margin:0 3rem 1rem;padding:1rem 1.2rem;background:#f6f6f6;color:#121212;border-left:3px solid #c92727;font-size:1.3rem;line-height:1.4;';
      div.textContent = 'Your cart holds one ' + n.label + ' at a time, so we kept “' + n.title + '”.';
      var header = inner.querySelector('.drawer__header');
      if (header && header.parentNode) header.parentNode.insertBefore(div, header.nextSibling);
      else inner.insertBefore(div, inner.firstChild);
      if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open();
      setTimeout(function () { if (div.parentNode) div.remove(); }, 10000);
    } catch (e) { }
  }

  function refreshUI(cart, notes) {
    try {
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ilres-cart-rules', cartData: cart });
      }
    } catch (e) { }
    try {
      nativeFetch('/?section_id=cart-icon-bubble')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.querySelector('.shopify-section');
          var target = document.getElementById('cart-icon-bubble');
          if (sec && target) target.innerHTML = sec.innerHTML;
        })
        .catch(function () { });
    } catch (e) { }
    Promise.all([refreshDrawer(), refreshCartPage()]).then(function () {
      setTimeout(function () { showNote(notes); mountTerms(); }, 300);
    });
  }

  // On the /cart page, re-render the line items and footer too.
  function refreshCartPage() {
    if (location.pathname.replace(/\/$/, '') !== '/cart') return Promise.resolve();
    return nativeFetch('/cart')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
          var fresh = doc.getElementById(id);
          var cur = document.getElementById(id);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function () { });
  }

  // Re-render the drawer's contents so it never shows a line we just removed.
  function refreshDrawer() {
    return nativeFetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.drawer__inner');
        var cur = document.querySelector('#CartDrawer .drawer__inner');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      })
      .catch(function () { });
  }

  function enforce() {
    if (window.__ilresCartRulesOff) return Promise.resolve();
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    return nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var plan = buildPlan(cart);
        if (!plan.changed) { known = keysOf(cart); return null; }
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: plan.updates })
        })
          .then(function (r) { return r.json(); })
          .then(function (newCart) {
            known = keysOf(newCart);
            refreshUI(newCart, plan.notes);
          });
      })
      .catch(function () { })
      .then(function () {
        busy = false;
        if (again) { again = false; enforce(); }
      });
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    if (isAdd(url)) {
      p.then(function (res) { if (res && res.ok) setTimeout(enforce, 400); }).catch(function () { });
    }
    return p;
  };

  try {
    var xhrOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (isAdd(url)) this.addEventListener('loadend', function () { setTimeout(enforce, 400); });
      } catch (e) { }
      return xhrOpen.apply(this, arguments);
    };
  } catch (e) { }

  var TERMS_SELECTOR = '#CartDrawer .drawer__footer .cart__ctas';

  function mountTerms() {
    try {
      if (!document.getElementById('CartDrawer')) return false;
      if (!window.roarJs || !roarJs.LegalConfig || !roarJs.Legal || !roarJs.LegalConfig.metafields) return false;
      var s = roarJs.LegalConfig.metafields.settings;
      if (!s) return false;
      s.installer = s.installer || {};
      var tid = String(window.Shopify && Shopify.theme && Shopify.theme.id);
      var cfg = s.installer[tid];
      if (!cfg) {
        cfg = s.installer[tid] = {};
        var other = Object.keys(s.installer).filter(function (k) { return k !== tid && s.installer[k] && s.installer[k].cart; })[0];
        if (other) cfg.cart = s.installer[other].cart;
      }
      cfg.minicart = { selector: TERMS_SELECTOR, position: 'before' };
      if (s.param) s.param.error_display = 'inline';
      roarJs.Legal.refresh();
      return true;
    } catch (e) {
      return false;
    }
  }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function init() {
    enforce();
    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
          if (evt && evt.source === 'ilres-cart-rules') return;
          setTimeout(enforce, 400);
          setTimeout(mountTerms, 600);
        });
      }
    } catch (e) { }
    var tries = 0;
    (function waitForApp() {
      if (mountTerms()) return;
      if (tries++ < 40) setTimeout(waitForApp, 500);
    })();
    var drawer = document.getElementById('CartDrawer');
    if (drawer && window.MutationObserver) {
      var check = debounce(function () { if (!drawer.querySelector('.rale-widget')) mountTerms(); }, 150);
      new MutationObserver(check).observe(drawer, { childList: true, subtree: true });
    }
    window.ilresCartRules = { enforce: enforce, mountTerms: mountTerms, groups: GROUPS };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
